export const gcpQueryKeys = {
  getMetadataAuthorization: (teamId: string) =>
    ['gcp/metadata/authorization', { teamId }] as const
}
